import { z } from 'zod';

export const YtdKpisSchema = z.object({
  income: z.number(),
  expenses: z.number(),
  margin: z.number(),
  marginPct: z.number(),
  incomeDeltaPct: z.number().nullable(),
  expensesDeltaPct: z.number().nullable(),
  marginDeltaPct: z.number().nullable(),
});
export type YtdKpis = z.infer<typeof YtdKpisSchema>;

export const MonthlyPnlRowSchema = z.object({
  month: z.number().int().min(1).max(12),
  monthLabel: z.string(),
  income: z.number(),
  expenses: z.number(),
  draft: z.number(),
});
export type MonthlyPnlRow = z.infer<typeof MonthlyPnlRowSchema>;

export const ExpensesByCategorySchema = z.object({
  category: z.string(),
  total: z.number(),
  pct: z.number(),
});
export type ExpensesByCategory = z.infer<typeof ExpensesByCategorySchema>;

export const PnlSummarySchema = z.object({
  incomeTotal: z.number(),
  incomeIrpfSubject: z.number(),
  incomeRest: z.number(),
  expensesTotal: z.number(),
  expensesByCategory: z.array(ExpensesByCategorySchema),
  taxBase: z.number(),
  irpfWithheld: z.number(),
  irpfPaymentsToAccount: z.number(),
  estimatedToPay: z.number(),
});
export type PnlSummary = z.infer<typeof PnlSummarySchema>;

export const ReportsQuery = z.object({
  fiscalYear: z.coerce.number().int().min(2000).max(2100).optional(),
  scope: z.string().optional(),
});
export type ReportsQuery = z.infer<typeof ReportsQuery>;
